import * as R from 'ramda'
import { DEFAULT_PARTICIPANTS_CATEGORY, PARTICIPANTS_CATEGORIES } from 'constants/participants'
import { RefreshStoredParticipants } from './types/refreshStoredParticipants.types'
import { cloneParticipantsObject } from '.'

export const refreshStoredParticipants: RefreshStoredParticipants = (
  participants
) => {
  const initialParticipants = R.isEmpty(participants)
    ? { ...participants }
    : cloneParticipantsObject(participants)

  return (
    PARTICIPANTS_CATEGORIES.reduce((refreshedParticipants, category) => {
      if (refreshedParticipants[category] !== refreshedParticipants[DEFAULT_PARTICIPANTS_CATEGORY]) {
        refreshedParticipants[category].number = refreshedParticipants[category].birthdates.length
      }
      return refreshedParticipants
    }, initialParticipants)
  )
}
